import React from 'react';
import ReactTypingEffect from 'react-typing-effect';

export default function TypedBody() {
    return (
        <>
          {/* <ReactTypingEffect
            text={["Hello.", "World!"]}
          /> */}
    
       
    
          <ReactTypingEffect
            text={[  "Keen Learner","Software Developer", "Full Stack Developer" , "Open Source Enthusiast" , "And a Competitor"]}
            cursorRenderer={cursor => <h2>{cursor}</h2>}
            displayTextRenderer={(text, i) => {
              return (
                <h2>
                  {text.split('').map((char, i) => {
                    const key = `${i}`;
                    return (
                      <span
                        key={key}
                        style={{color : 'rgb(115, 32, 194)'}}
                        // style={i%2 === 0 ? { color: 'magenta'} : {}}
                      >{char}</span>
                    );
                  })}
                </h2>
              );
            }}        
          />
        </>
      );
}
